import { getItemWrapperClass, renderFreeBusyBar } from '../CalendarSurfaceItemComponentRenderer';
import { differenceInMilliseconds } from 'owa-datetime';
import { observer } from 'mobx-react';
import * as React from 'react';
import {
    BaseComponent,
    classNamesFunction,
    customizable,
} from 'office-ui-fabric-react/lib/Utilities';
import {
    getCalendarEventItemAriaLabel,
    getCalendarEventItemTitle,
} from 'owa-calendar-event-attributes';
import {
    CalendarSurfaceItemProps,
    CalendarSurfaceItemStyleProps,
    CalendarSurfaceItemStyles,
} from './CalendarSurfaceItem.types';
import { getUserOptions } from 'owa-session-store';
import { isFeatureEnabled } from 'owa-feature-flags';

let surfaceItemStyles = require('../CalendarSurfaceItem.scss');
let classNames = require('classnames/bind').bind(surfaceItemStyles);

const getClassNames = classNamesFunction<
    CalendarSurfaceItemStyleProps,
    CalendarSurfaceItemStyles
>();

/**
 * Template for calendar items on day/week view
 */
@customizable('CalendarSurfaceItem', ['theme'])
@observer
export default class CalendarSurfaceItemBase extends BaseComponent<CalendarSurfaceItemProps, {}> {
    render() {
        let {
            freeBusyType,
            colorScheme,
            charmId,
            hideFreeBusyBar,
            dimPastEvents,
            className,
            ariaLabel,
            title,
            disableTabIndex,
            onRender,
            responseType,
            isCancelled,
            hideBorder,
            theme,
            styles,
            duration,
            item,
            itemState,
            allowEmptySubject,
        } = this.props;

        if (item) {
            // assign properties that come from the item if they're undefined- check undefined explicitly in case of falsy/zero values
            freeBusyType = freeBusyType != undefined ? freeBusyType : item.FreeBusyType;
            responseType = responseType != undefined ? responseType : item.ResponseType;
            duration =
                duration != undefined ? duration : differenceInMilliseconds(item.End, item.Start);
        }

        const useBoldTheme =
            isFeatureEnabled('cal-surface-boldColorTheme') &&
            getUserOptions().UseBoldCalendarColorThemeReact;
        hideFreeBusyBar = hideFreeBusyBar && !useBoldTheme; // never hide FB bars with bold theme

        const classes = getClassNames(styles, {
            theme: theme!,
            className,
            dimPastEvents,
            freeBusyType,
            responseType,
            colorScheme,
            charmId,
            isCancelled: isCancelled || responseType == 'Decline',
            hideBorder,
            useBoldTheme: useBoldTheme,
        });

        const childrenProps = {
            contentClass: classes.content,
            item,
            colorScheme,
            charmId,
            itemState,
            allowEmptySubject,
        };

        const timeZoneId = itemState && itemState.timeZoneId;

        ariaLabel =
            ariaLabel || !item ? ariaLabel : getCalendarEventItemAriaLabel(item, timeZoneId);

        title = title !== undefined || !item ? title : getCalendarEventItemTitle(item, timeZoneId);

        className = className || !item ? className : getItemWrapperClass(item, dimPastEvents);

        return (
            <div
                role={disableTabIndex ? undefined : 'button'}
                className={classNames(classes.root, surfaceItemStyles.wrapperDiv, className, {
                    wrapperDivHiddenFB: hideFreeBusyBar,
                })}
                tabIndex={disableTabIndex ? undefined : 0}
                aria-label={ariaLabel}
                title={title}>
                {!hideFreeBusyBar && renderFreeBusyBar(freeBusyType, duration, colorScheme)}
                <div className={classNames(surfaceItemStyles.colorWrapper, classes.content)}>
                    <div className={surfaceItemStyles.contentWrapper}>
                        {onRender && onRender(childrenProps)}
                    </div>
                </div>
            </div>
        );
    }
}
